import React, { useState } from 'react';
import { format, parse, isValid } from 'date-fns';
import { id as idLocale } from 'date-fns/locale';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Button } from './ui/button';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { cn } from '../lib/utils';

/**
 * Date picker with a calendar popover.
 * value / onChange work in "YYYY-MM-DD" string format.
 */
const DatePickerPopover = ({ value, onChange, disabled, placeholder = 'Pilih tanggal', testId }) => {
  const [open, setOpen] = useState(false);
  const parsed = value ? parse(value, 'yyyy-MM-dd', new Date()) : null;
  const displayDate = parsed && isValid(parsed) ? parsed : null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          className={cn(
            'w-full min-w-0 justify-start text-left font-normal h-10 px-3',
            !displayDate && 'text-muted-foreground'
          )}
          data-testid={testId}
        >
          <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />
          <span className="truncate">
            {displayDate ? format(displayDate, 'd MMM yyyy', { locale: idLocale }) : placeholder}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={displayDate}
          onSelect={(d) => {
            if (!d) { onChange(''); }
            else { onChange(format(d, 'yyyy-MM-dd')); }
            setOpen(false);
          }}
          initialFocus
        />
        {displayDate && (
          <div className="p-2 border-t border-border flex justify-end">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => { onChange(''); setOpen(false); }}
              className="text-xs"
              data-testid={testId ? `${testId}-clear` : undefined}
            >
              Hapus
            </Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default DatePickerPopover;
